import { Box, styled } from "@mui/material";
import { HEADER, NAVBAR } from "config";
import useCollapseDrawer from "hooks/useCollapseDrawer";
import useResponsive from "hooks/useResponsive";
import useSettings from "hooks/useSettings";
import OnboardingHeader from "pages/onboarding/OnboardingHeader";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "redux/store";

type MainStyleProps = {
  collapseClick: boolean;
  fitViewport?: boolean;
};

const HEADER_HEIGHT = { xs: 56, sm: 64 };

const MainStyle = styled("main", {
  shouldForwardProp: (prop) =>
    prop !== "collapseClick" && prop !== "fitViewport",
})<MainStyleProps>(({ collapseClick, fitViewport, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT,
  paddingBottom: HEADER.MOBILE_HEIGHT,
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 10,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT - 30,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    height: fitViewport ? `calc(100vh - ${HEADER_HEIGHT.sm}px)` : "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: theme.transitions.create("margin-left", {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

interface OnboardingLayoutProps {
  children?: any;
}

const OnboardingLayout = ({ children }: OnboardingLayoutProps) => {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const { themeLayout } = useSettings();
  const isDesktop = useResponsive("up", "lg");
  const [open, setOpen] = useState(false);
  const customOnboardingTemplate = useSelector(
    (state) => state.supplier.supplier?.customOnboardingTemplate,
  );
  const fitViewport = !customOnboardingTemplate;
  return (
    <Box>
      <OnboardingHeader />
      <Box
        sx={{
          display: "flex",
          minHeight: fitViewport
            ? {
                xs: `calc(100vh - ${HEADER_HEIGHT.xs}px)`,
                sm: `calc(100vh - ${HEADER_HEIGHT.sm}px)`,
              }
            : "100vh",
        }}
      >
        <MainStyle collapseClick={collapseClick} fitViewport={fitViewport}>
          <Box sx={{ pb: 5 }}>{children ? children : <Outlet />}</Box>
        </MainStyle>
      </Box>
    </Box>
  );
};

export default OnboardingLayout;
